"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ViewDebtRouter_1 = require("../../../components/Pages/ViewDebt/ViewDebtRouter");
var withRouter_1 = require("../../hooks/withRouter");
var ViewDebt = function (props) {
    return React.createElement(ViewDebtRouter_1.default, { reference: props.router.params.reference });
};
exports.default = (0, withRouter_1.default)(ViewDebt);
